export const STATUSES = [
  { id: 'todo',       label: 'To Do',       color: '#64748b', bg: '#f1f5f9', border: '#e2e8f0' },
  { id: 'inprogress', label: 'In Progress', color: '#6C63FF', bg: '#ede9fe', border: '#c4b5fd' },
  { id: 'done',       label: 'Done',        color: '#10b981', bg: '#d1fae5', border: '#6ee7b7' },
];

export const PRIORITIES = {
  high:   { label: 'High',   color: '#ef4444', bg: '#fee2e2' },
  medium: { label: 'Medium', color: '#f59e0b', bg: '#fef3c7' },
  low:    { label: 'Low',    color: '#64748b', bg: '#f1f5f9' },
};

export const PROJECT_COLORS = [
  '#6C63FF', '#43C6AC', '#F7971E', '#FF6584',
  '#4facfe', '#a18cd1', '#f953c6', '#1de9b6',
];
